import { LicenseTester, Model, StringUtil } from "@mcleod/core";
import { ChangeEvent } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { AutogenLayoutOptionalSettings } from "./autogen/AutogenLayoutOptionalSettings";

export class OptionalSettings extends AutogenLayoutOptionalSettings {

    private macropointRequestorId = "";
    private shownNotification = false;


    constructor() {
        super();
    }


    textboxGooglePlaceIdOnDataDisplay(event) {
        const googlePlaceId = this.textboxGooglePlaceId.text;
        if(googlePlaceId) {
            this.checkboxIsGeocoded.checked = true;
        }
    }



    textboxMacropointRequestorIdOnChange(event: ChangeEvent) {
        if(event.userInitiatedChange){
            if(!this.shownNotification && !StringUtil.isEmptyString(this.macropointRequestorId)){
                this.showNotificationMessage();
                this.shownNotification = true;
            }
        }else{
            this.macropointRequestorId = this.textboxMacropointRequestorId.text;
        }
    }


    textboxCustRequestorLoadIdOnChange(event: ChangeEvent){
        if(!StringUtil.isEmptyString(event.oldValue) && !this.shownNotification){
            this.showNotificationMessage();
            this.shownNotification = true;
        }
    }

    textboxIntegrationTypeOnChange(event: ChangeEvent){
        if(!StringUtil.isEmptyString(event.oldValue) && !this.shownNotification && !StringUtil.equalsIgnoreCase("Data Export",event.newValue)){
           this.showNotificationMessage();
           this.shownNotification = true;
        }
    }
    showNotificationMessage(){
        CommonDialogs.showMessage("Changes will apply to the next tracking initiation. Loads actively tracking will not reflect the update.", "Notification");

    }

    /** This is an event handler for the afterDropdownSelection event of textboxSummaryBilling. */
    async textboxSummaryBillingAfterDropdownSelection() {
        const isAccountingInterfaceLicensed =
            LicenseTester.testPackage("com.tms.client.loadmaster.accountinginterface");
        const response = await Model.searchSingleRecord("lme/settlement/accounting-ctrl", null, ["billh_export", "cashreceipts_import"]);
        if(!isAccountingInterfaceLicensed || !(response.getBoolean("billh_export", false) || response.getBoolean("cashreceipts_import", false))) {
            const billMethod = this.textboxSummaryBilling.text;
            if(billMethod === "Summary" || billMethod === "Dedicated") {
                this.checkboxPostSummaryDtl.checked = true;
                this.checkboxPostSummaryDtl.enabled = true;
            } 
            else {
                this.checkboxPostSummaryDtl.checked = false;
                this.checkboxPostSummaryDtl.enabled = false;
            }
        }
    }
}
